<div class="d-flex flex-grow-1 w-100 me-auto align-items-center">
  <app-app-logo />
  <app-toggle-mobile-menu />
  <app-toggle-sidenav />
</div>

<button
  type="button"
  class="btn btn-system"
  aria-label="Open Sources"
  (click)="layoutStore.toggleSource()"
>
  <svg class="sa-icon sa-medium">
    <use href="/assets/icons/sprite.svg#paperclip"></use>
  </svg>
</button>

<app-theme-toggle />
<app-notification-dropdown />

<app-toggle-fullscreen class="d-none d-lg-block" />
<app-profile-dropdown />
